(function () {
  'use strict';

  function initStickyAtcChips() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var chips = document.querySelector('[data-duvar-set] fieldset[data-option-handle="boyut"]');
    var atc = document.querySelector('.set-sticky-atc, .product-sticky-atc, sticky-atc-bar');
    if (!chips || !atc) return;
    var sync = function () {
      if (atc.hasAttribute('hidden')) {
        atc.classList.remove('is-held-for-chips');
        return;
      }
      var cr = chips.getBoundingClientRect();
      var vh = window.innerHeight || 844;
      var atcH = atc.offsetHeight || 72;
      var cover = cr.bottom > vh - atcH - 12 && cr.top < vh;
      atc.classList.toggle('is-held-for-chips', cover);
    };
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['hidden'] });
    }
    sync();
    setTimeout(sync, 400);
    setTimeout(sync, 1200);
  }

  /* P1/P2: Chat widget offset for sticky ATC */
  function initChatSafeArea() {
    function measure() {
      var chat = document.querySelector('#shopify-chat, .needsclick.kl-private-reset-css-Xuajs1');
      var h = chat && chat.offsetParent !== null ? chat.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--chat-widget-offset', h > 40 ? Math.min(h * 0.35, 56) + 'px' : '0px');
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
    setTimeout(measure, 2500);
  }

  function boot() {
    initChatSafeArea();
    initStickyAtcChips();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
